export const formatUSD = (value) => {
  if (value === null || value === undefined || value === "") return "-";

  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
  }).format(value);
};

export const formatNumberUS = (value) => {
  if (value === null || value === undefined || value === "") return "-";

  return new Intl.NumberFormat("en-US").format(value);
};